import { DataErrorMessage, DataErrorMessageEnum } from '@cumlaude/service-contract';

export function isHappyContext<C extends object>(context: C | DataErrorMessage): context is C {
	return !('error' in context);
}

export function isErrorContext<C extends object>(context: C | DataErrorMessage): context is DataErrorMessage {
	return 'error' in context;
}

export function parseError(error: any): DataErrorMessage {
	const parsed = parseIfString(error);
	if (isDataErrorMessage(parsed)) return parsed;

	if (typeof error === 'object' && error !== null) {
		return {
			error: DataErrorMessageEnum.UNKNOWN,
			message: `Unknown error type: ${error.constructor.name}`,
		};
	}

	return {
		error: DataErrorMessageEnum.UNKNOWN,
		message: String(error),
	};
}

export function parseIfString(value: any): DataErrorMessage | undefined {
	if (typeof value !== 'string') return value;

	try {
		return JSON.parse(value);
	} catch {
		return {
			error: DataErrorMessageEnum.UNKNOWN,
			message: value,
		};
	}
}

export function isDataErrorMessage(value: any): value is DataErrorMessage {
	return typeof value === 'object' && value !== null && 'error' in value;
}
